export default __webpack_public_path__ + "static/media/sidebar-torneo.94daf338.jpg";